export const whatIsVSTTText = "is a value-add, self-test, simulator tool working with a Visa Directory Server to provide issuer ACS and 3DS (Directory Server) Server entities the ability to run extended tests or validation of their EMV 3DS (Directory Server) implementations. This offering is available in two testing environments: Production and Pre-Production. A one-time setup fee and recurring subscription fee separately apply for each VSTT test tool. "
export const merchantSimulatorText = "VSTT Merchant is an eCommerce merchant simulator that communicates with the Visa Directory Server for issuers to send and receive test EMV 3DS (Directory Server) messages. It is available for Pre-Production testing and production testing in browser based, iOS based, and Android OS based environments. "
export const acsText = "VSTT Test ACS is a simulated ACS that communicates with the Visa Secure Directory Server for merchants and 3DS (Directory Server) Servers to send and receive test EMV 3DS (Directory Server) messages. It is available for Pre-Production testing and production testing in browser based, iOS based, and Android OS based environments. "
  export const ListItems = [
    {
      content: 'EMV 3DS (Directory Server) solution providers and participants must complete the EMVCo 3DS (Directory Server) compliance testing and Visa Secure certification testing prior to using any of the VSTT test tools. ',
      pre:"Prior Testing:"
    },
    {
      content: 'ACS servers or 3DS (Directory Server) servers must request 3DS (Directory Server) certificates to connect with the Visa DS in Production and/or Pre-Production environments prior to use. ',
      pre:"Connection Certificates:"
    },
    {
      content: 'Issuers must set up their account ranges with the Visa DS in Production and/or Pre-Production environments prior to use. ',
      pre:"Account Range Setup:"
    },
    {
      content: '3DS (Directory Server) servers must ensure that the acquiring IDs used are set up with the Visa DS in Pre-Production and/or in Production environments prior to use. ',
      pre:"Acquiring Identifiers:"
    },
  ];
  export const TableItems = [
    {
      content: 'Log in to Visa Secure Services (VSS). ',
    },
    {
      content: 'Review the additional VSTT resources in the VSS Library. ',
    },
    {
      content: 'Navigate to the VSS Store and select the VSTT product and environment. ',
    },
    {
      content: 'Confirm selection(s) and place the order to be invoiced to your Visa BID. ',
    },
  ];
  export const TableItemsVertical = [
    {
      content: 'Log in to Visa Secure Services (VSS). ',
    },
    {
      content: 'Review the additional VSTT resources in the VSS Library. ',
    },
    {
      content: 'Navigate to the VSS Store and select the VSTT product and environment. ',
    },
    {
      content: 'Confirm selection(s) and place the order to be invoiced to your Visa BID. ',
    },
  ];
  export const Steps = [
    {
      content: 'Step 1',
    },
    {
      content: 'Step 2',
    },
    {
      content: 'Step 3',
    },
    {
      content: 'Step 4',
    },
  ];
  export const StepsVertical = [
    { step: 'Step 1', instruction: 'Log in to Visa Secure Services (VSS).' },
    { step: 'Step 2', instruction: 'Review the additional VSTT resources in the VSS Library.' },
    { step: 'Step 3', instruction: 'Navigate to the VSS Store and select the VSTT product and environment.' },
    { step: 'Step 4', instruction: 'Confirm selection(s) and place the order to be invoiced to your Visa BID.' },
  ];